import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { goddivaInvoiceReportApi, exportInvoiceRowApi, goddivaInvoiceByIdApi } from "../../../../services/report";

/**
 *  Get Invoice By ID (Summary + Items)
 */
export const getInvoiceById = createAsyncThunk(
    'report/getInvoiceById',
    async (data) => {
        //  adjust endpoint if needed
        const response = await goddivaInvoiceByIdApi(data);
        // console.log('response from API', response);
        return response;
    }
);

/**
 *  Entity Adapter
 */
const salesInvoiceAdapter = createEntityAdapter({});

/**
 *  Selectors
 */
export const {
    selectAll: selectSalesInvoiceReport,
    selectById: selectSalesInvoiceReportById
} = salesInvoiceAdapter.getSelectors(
    state => state.report.salesInvoiceReport
);

/**
 *  Slice
 */
const salesInvoiceItemReportSclice = createSlice({
    name: 'salesInvoiceItemReport',

    initialState: salesInvoiceAdapter.getInitialState({
        id: null,
        salesInvoiceTableRow: 0,
        totalItems: 0,
        viewLoading: true,

        // NEW STATES
        selectedInvoice: null,
        invoiceItems: [],
        // viewLoading: false
    }),

    reducers: {
        setTableRowCount: (state, action) => {
            state.totalItems = action.payload;
        },

        // Optional reset
        clearInvoiceView: (state) => {
            state.selectedInvoice = null;
            state.invoiceItems = [];
            state.totalItems = 0;
            state.viewLoading = true;
        }
    },

    extraReducers: (builder) => {
        builder

             
            .addCase(getInvoiceById.pending, (state) => {
                state.viewLoading = true;
            })

            .addCase(getInvoiceById.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload.invoice !== undefined) {
                    state.selectedInvoice = payload.invoice;
                }
                // Handle all possible shapes: array, {results:[]}, {data:[]}, or fallback
                const raw = payload.items;
                const items = Array.isArray(raw) ? raw
                    : Array.isArray(raw?.results) ? raw.results
                    : Array.isArray(raw?.data) ? raw.data
                    : [];
                state.invoiceItems = items;
                state.totalItems = payload.items.total;
                state.viewLoading = false;
            })

            .addCase(getInvoiceById.rejected, (state) => {
                state.viewLoading = false;
            });
    }
});

/**
 *  Actions
 */
export const {
    setTableRowCount,
    clearInvoiceView
} = salesInvoiceItemReportSclice.actions;

/**
 *  Reducer
 */
export default salesInvoiceItemReportSclice.reducer;